 var cannotLoadAjax = "Can not process your request";
 var makeText = 'Make';
 var yearText = 'Year';
 var modelText = 'Model';
 var loadingText = 'Loading';
 var engineText = 'Engine';

 document.addEventListener('DOMContentLoaded', function() {   
    $("#errorDiv").hide();

   $("#Year").change(function () { 
      switchSelectedColor("Year");      
      GetModelSelectList();                
      tonggleSubmitBtn();
    });

    $("#Make").change(function () { 
       //switchSelectedColor("Make");     
       GetYearSelectList();
       //tonggleSubmitBtn();
    });

    $("#ModelName").change(function () {
      switchSelectedColor("ModelName");      
      tonggleSubmitBtn();
      if($("#EngineType").length ){
        GetEngineTypeSelectList();
      }      
    });

    $("#EngineType").change(function () { 
      switchSelectedColor("EngineType");      
      tonggleSubmitBtn();
    });    
   
    $('#frmVehicleSM').keypress(function (event) {
        if (event.keyCode == 13) {
            //searchVehicleSM();
            return false;
        }
    });

    // $('#Mileage').keypress(function (event) {
    //     return typingNumber(event);
    // });

    $('#Mileage').keyup(function (event) {     
      tonggleSubmitBtn();          
    });
   
    $('#Mileage').keydown(function (event) {
        return onlyNumbers(event);
    });

    GetMakeSelectList();    
   
    //Captchar
    var captchaKey = $("#GoogleCaptchaKey").val();
    $("div.g-recaptcha").attr("data-sitekey", captchaKey);  
  	$("#captcharDiv").hide();    
   
     $('.select2').select2({
        dropdownParent: $('.vehicle-sm')
    });
   
  });

var actCallback = function (response) {
  searchSM();
  $("#captcharDiv").hide();

};
var expCallback = function() {
  grecaptcha.reset(0);
  setTimeout(function(){
    grecaptcha.reset(0);
  }, 30000);
};

var onloadCallback = function () {
  var captchaKey = $("#GoogleCaptchaKey").val();
  var widget = grecaptcha.render(document.getElementById("re-captcha"), {
    'sitekey' : captchaKey, // Sitekey, Retrieving from reCaptcha
    'theme': "light",
    'callback' : actCallback,
    'expired-callback': expCallback,   
  });
}

function tonggleSubmitBtn(){
  var year = $("#Year").val();
  var make = $("#Make").val();
  var modelName = $("#ModelName").val();
  var engineType = $("#EngineType").val();		
  var mileage = $("#Mileage").val();

  if(year=="" || make=="" || modelName=="" || engineType=="" || mileage==""  || (mileage != undefined && mileage != null && parseInt(mileage.trim())==0)){
    $("#searchBtn").addClass('inactive');      
  }else{
    $("#searchBtn").removeClass('inactive');
  }  
}

function typingNumber(e){
  var code = e.keyCode || e.which; 
  if ((code != 8 && code != 13) && (code < 48 || code > 57)){
     return false;
   }  
}

function searchVehicleSM(){
  var numberOfClicksCookie = getCookie("veh-sm-search-times");
  var numberOfClicks =  numberOfClicksCookie != undefined && numberOfClicksCookie != null ? JSON.parse(numberOfClicksCookie) : [];    

  if(numberOfClicks.length < queryCount){
     numberOfClicks.push(new Date().getTime());
     setCookie("veh-sm-search-times", JSON.stringify(numberOfClicks), 0);
     searchSM();           
  }else{         
      var diff = numberOfClicks[numberOfClicks.length -1] - numberOfClicks[0] ;            
      if(diff < captInMiliSecond){ //15s
        $('#re-captcha').show();             
        grecaptcha.reset(0);
        $("#captcharDiv").show();                 
      }else{
          numberOfClicks.shift();
          numberOfClicks.push(new Date().getTime());    
          
          setCookie("veh-sm-search-times", JSON.stringify(numberOfClicks), 0);
          searchSM();                
       }
  }

  return false;
}

function searchSM(){
  $("#errorDiv").hide();
  
    var validEngine = $("#EngineType option").length > 1;
    var isValidForm = validateForm(validEngine);

    if (isValidForm) {        
        $("#searchBtn").attr('disabled','disabled');      
        $('#ModalContentAjax').modal("show");		

		var year = $("#Year").val();
		var make = $("#Make").val();
		var modelName = $("#ModelName").val();
		var engineType = correctString($("#EngineType").val());		
        var mileage = $("#Mileage").val();
        var requestData = {
                    "Year": year,
                    "Make": make,
                    "ModelName": modelName,
                    "EngineType": engineType,
                    "Mileage": parseInt(mileage.trim())
                    };
      try{       
          xhr = $.ajax({
              type: "POST",              
              url: "/apps/innova-api/vehicles/search-sm",
              headers : {'Content-Type': 'application/json'},
              dataType: "json",
              data: JSON.stringify(requestData),
              error: function (jqXHR, exception) {
                grecaptcha.reset(0);
                $('#ModalContentAjax').modal("hide");
                $("#searchBtn").removeAttr('disabled');
                if (jqXHR.status == 400){
                  alert(jqXHR.responseJSON.message.description);
                }else{
                  alert(cannotLoadAjax);
                }
              },
              success: function (result) {
                if (result.message.success) {                  
                    //render result
                    renderResult(result.data, year, make, modelName, engineType);
                    initDropdownPopup();
                    $("#searchBtn").removeAttr('disabled');     
                    $("#firstSMContent").addClass("d-none");
                    $("#resultSMContent").removeClass("d-none");

                    jumpTo('resultSMContent');
                } else {                                                               
                    $("#errorDiv").html(result.message.description);
                    $("#errorDiv").show(); 
                }			
                $('#ModalContentAjax').modal("hide");
                $("#searchBtn").removeAttr('disabled');
                grecaptcha.reset(0);
              }
          });
     
        }catch(e)
        {
          $('#ModalContentAjax').modal("hide");
          $("#searchBtn").removeAttr('disabled');
        }      
    }

    return false;
}
function renderResult(searchResult, vehicleYear, vehicleMake, vehicleModel, vehicleEngine){
  var vehicleYMM = vehicleYear + " " + vehicleMake + " " + vehicleModel;
  $("#vehicleContent").html(vehicleYMM);
  if(searchResult.hasData){
    $("#mileageContent").html(searchResult.nextMileage);

    var data = searchResult;
    var result = "";  
    var size = data.ratingSMs.length;
    if( size > 0)
    {
      if(size > 5){
        size = 5;
      }
      for (var i = 0; i < size; i++) {
        if(i<2){
          result += "<div class='mb-4'>";          
        }else{
          if(i==2){
            result+="<p><a id='viewMoreSM' href='javascript:viewAllSMs()' class='inv-error'><small>...click to expand</small></a></p>";
          }
          result += "<div class='mb-4 d-none more-sm'>";
        }
        
        result += " <h6 class='mb-4'>"+ data.ratingSMs[i].fixName +"</h6>";
        if(data.ratingSMs[i].fixRating > 0){
          result += renderRatingSM(data.ratingSMs[i].fixRating);
        }
        result += "<p class='mb-4'> Repair Difficulty </p>";
        if(data.ratingSMs[i].parts.length > 0){        
          var parts= data.ratingSMs[i].parts;
          for(var p =0; p < parts.length; p++)
          {
            var displayPart = vehicleYMM + " " + parts[p].partName;
            result += "<a href='https://www.amazon.com/s?k=" + displayPart + "&maas=maas_adg_9787CD8031971AA84BF0E4A83BE187F8_afap_abs&tag=innova07-20&ref=aa_maas' target='_blank' class='btn btn-danger mb-2'> Purchase " + displayPart +"</a>";
            result += "<p class='cl-gray mb-4'>~"+ parts[p].partsCost +"</p>";
          }
        }else{
          result += "<a href='javascript:;' class='btn btn-danger mb-2 pe-none'>N/A</a>";
          result += "<p class='cl-gray mb-4'>~N/A</p>";
        }
        result += "</div>";

        if(i == (size - 1)){
          if(i >= 2){
            result +="<div class='more-sm d-none'><p><small>For more details, please download our <a target='_blank' href='/pages/repairsolutions2-app' class='inv-error'>RS2 app</a></small></p></div>";
          }else{
            result +="<p><small>For more details, please download our <a target='_blank' href='/pages/repairsolutions2-app' class='inv-error'>RS2 app</a></small></p>";
          }
        }
      }
      
    }else if (data.seviceSMs.length > 0){
      for (var i = 0; i < data.seviceSMs.length; i++) {
        if(i==5)
          break;
        result += " <h6 class='mb-4'>"+ data.seviceSMs[i] +"</h6>";
        //  if(i<5){
        //   result += " <h6 class='mb-4'>"+ data.seviceSMs[i] +"</h6>";
        // }else{
        //   if(i==5){
        //     result+="<p><a id='viewMoreSM' href='javascript:viewAllSMs()' class='inv-error'><small>...click to expand</small></a></p>";
        //   }
        //   result += " <h6 class='mb-4 d-none more-sm'>"+ data.seviceSMs[i] +"</h6>";
        // }        
      }
    }
    $("#fixesContent").html(result);
    $("#confirmSMContent").show();
  }else{
    $("#confirmSMContent").hide();
    $("#fixesContent").html("We apologize, however, our database currently does not contain Scheduled Maintenance Information on this specific vehicle.");
  }
}

function viewAllSMs(){
  $("#viewMoreSM").hide();
  $("#fixesContent").find(".more-sm").removeClass("d-none");
}

function renderRatingSM(rating){
  var ratingImg = "";
  switch(rating)  
    {
      case 1:
        ratingImg = "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/difficulty-01.png?v=1711525908";
          break;
      case 2:
        ratingImg = "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/difficulty-02.png?v=1711525908";
        break;
      case 3:
        ratingImg = "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/difficulty-03.png?v=1711525908";
        break;
      case 4:
        ratingImg = "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/difficulty-04.png?v=1711525908";
        break;
      case 5:
        ratingImg = "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/difficulty-05.png?v=1711525908";
        break;
    }
  
  return "<img src='" + ratingImg + "' alt='' width='120'/>";
}

function validateForm(validEngine) {
  $("#Year").addClass("required").removeClass("inv-error");
  $("#Make").addClass("required").removeClass("inv-error");
  $("#ModelName").addClass("required").removeClass("inv-error");
  $("#EngineType").removeClass("required").removeClass("inv-error");
  $("#Mileage").removeClass("required").removeClass("inv-error");
      
  if(validEngine){
    $("#EngineType").addClass("required");    
  }
  
  if(!checkRequiredFields('frmVehicleSM')){
    return false;
  } 
  var mileage = $("#Mileage").val();
  if(mileage < 1){
    $("#errorDiv").html("Mileage must be larger than zero");
    $("#errorDiv").show();
    return false;
  }
  
  return true;
}

function correctString(val){
    return (val == undefined || val == null) ? "" : val;  
}

function correctBool(val){
      return (val == undefined || val == null) ? false : val.toLowerCase() === 'true';  
}
function initDropdownPopup() {     
    $(".inv-coverage2 .dropdown-menu").click(function(e){
	    e.stopPropagation();
	});	
	$(".inv-coverage2 .inv-dropdown-custom-close").click(function(e){
	    $(".inv-coverage2 .inv-dropdown-custom").removeClass('open');
	});	 
}

function switchSelectedInfo(){
   switchSelectedColor("Make");
   switchSelectedColor("Year");  
   switchSelectedColor("ModelName"); 
   switchSelectedColor("EngineType"); 
   tonggleSubmitBtn();
}

function switchSelectedColor(ctrlId){
  var val =  $("#" + ctrlId).val();
  if(val != ""){
     $("#" + ctrlId).parent().find("span.select2-selection__rendered").addClass("inv-selected");
  }else{
      $("#" + ctrlId).parent().find("span.select2-selection__rendered").removeClass("inv-selected");
  }
}

function GetYearSelectList(selectedYear) {   
  var make = $("#Make").val();
  if (make == "") {
        $("#Year").html("<option value=''>" + yearText + "</option>");
        $("#ModelName").html("<option value=''>" + modelText + "</option>");
        $("#EngineType").html("<option value=''>" + engineText + "</option>");
        $("#EngineType").change();
        $("#Year").change();
        $("#ModelName").change();
        switchSelectedInfo();
        return false;
    }
    $('#ModalContentAjax').modal("show");
    var url = "/apps/innova-api/vehicles/"+ make +"/Years/?r=" + Math.random();
    $.ajax({
        type: "POST",
        
        url: url,
        error: function (jqXHR, exception) {
          $('#ModalContentAjax').modal("hide");            
            alert(cannotLoadAjax);     
        },
        success: function (ret) {
          //if (ret.message.success) {
            var result = ret.years;          
            var options = "<option value=''>" + yearText + "</option>";
            for (var i = 0; i < result.length; i++) {
              if( result[i] == selectedYear){
                options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
              }else{
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
              }              
            }
            $("#Year").html(options);
            $("#ModelName").html("<option value=''>" + modelText + "</option>");
            $("#EngineType").html("<option value=''>" + engineText + "</option>");

            switchSelectedInfo();
            $("#Year").select2('focus');
   //        } else {                                                               
			// 	$("#errorDiv").html(ret.message.description);
			// 	$("#errorDiv").show(); 
			// }          
            $('#ModalContentAjax').modal("hide");
        }
    });
}

function GetMakeSelectList(selectedMake) {    
    $("#Make").html("<option value=''>" + loadingText + "...</option>");
    var url = "/apps/innova-api/vehicles/Makes/?r=" + Math.random();
    
    //$('#ModalContentAjax').modal("show");
    xhr = $.ajax({
        type: "GET",        
        url: url,
        error: function (jqXHR, exception) {
           $('#ModalContentAjax').modal("hide");            
            alert(cannotLoadAjax);      
        },
        success: function (ret) {
			//if (ret.message.success) {
              var result = ret.makes;
              var options = "<option value=''>" + makeText + "</option>"; 
              for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedMake){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }               
              }
              $("#Make").html(options);
              $("#Year").html('<option value="">'+ yearText +'</option>');
              $("#ModelName").html('<option value="">'+ modelText +'</option>');
              $("#EngineType").html("<option value=''>" + engineText + "</option>");
              
              switchSelectedColor("Make");       
              
          
              $("#Make").select2('focus');
             
            // }else{
            //   $("#Make").html("<option value=''>" + makeText + "</option>");              
            // }
           // $('#ModalContentAjax').modal("hide");
        }
    });

}

function GetModelSelectList(selectedModel) {
    var make = $("#Make").val();
    var year = $("#Year").val();

    if (year == "") {
        $("#ModelName").html("<option value=''>" + modelText + "</option>");
        $("#EngineType").html("<option value=''>" + engineText + "</option>");
        $("#EngineType").change();
        $("#ModelName").change();
        switchSelectedInfo();
        return false;
    }
    $("#ModelName").html("<option value=''>" + loadingText + "...</option>");
    var url = "/apps/innova-api/vehicles/" + make + "/" + year + "/Models/?r=" + Math.random();

    $('#ModalContentAjax').modal("show");
    $.ajax({
        type: "POST",        
        url: url,
        error: function (jqXHR, exception) {
            $('#ModalContentAjax').modal("hide");            
            alert(cannotLoadAjax);           
        },
        success: function (ret) {
          //if (ret.message.success) {
            var result = ret.models;
            var options = "<option value=''>" + modelText + "</option>";
            for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedModel){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }
            }
            $("#ModelName").html(options);
            $("#EngineType").html("<option value=''>" + engineText + "</option>");
            //$('.selectpicker').selectpicker('refresh');

            switchSelectedInfo();
            $("#ModelName").select2('focus');
            
          // }else{
          //    $("#ModelName").html("<option value=''>" + modelText + "</option>");           
          // }
          $('#ModalContentAjax').modal("hide");
        }
    });
}

function GetEngineTypeSelectList(selectedEngine) {
    var make = $("#Make").val();
    var year = $("#Year").val();
    var model = $("#ModelName").val();

    if (model == "") {
        $("#EngineType").html("<option value=''>" + engineText + "</option>");
        $("#EngineType").change();
        switchSelectedInfo();
        return false;
    }
    $("#EngineType").html("<option value=''>" + loadingText + "...</option>");
   // var url = "/apps/innova-api/vehicles/" + make + "/" + year + "/" + encodeURIComponent(encodeURIComponent(model)) + "/engines/?r=" + Math.random();
    var url = "/apps/innova-api/vehicles/" + make + "/" + year + "/" + encodeURIComponent(model) + "/engines/?r=" + Math.random();
  	$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "POST",        
        url: url,
        error: function (jqXHR, exception) {
            $('#ModalContentAjax').modal("hide");            
            alert(cannotLoadAjax);     
        },
        success: function (ret) {
          //if (ret.message.success) {
            var result = ret.engines;
          	var options = result.length == 1? "": "<option value=''>" + engineText + "</option>";
            for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedEngine){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }
            }
            $("#EngineType").html(options);
            switchSelectedInfo();      

            $("#EngineType").select2('focus');
          // }else{
          //    $("#EngineType").html("<option value=''>" + engineText + "</option>");             
          // }
          $('#ModalContentAjax').modal("hide");
        }
    });
}

function jumpTo(anchor_id){
  var url = location.href;               //Saving URL without hash.
  location.href = "#"+anchor_id;                 //Navigate to the target element.
  history.replaceState(null,null,url);   //method modifies the current history entry.
}

function onlyNumbers(event) {
  if (event.type == "paste") {
    var clipboardData = event.clipboardData || window.clipboardData;
    var pastedData = clipboardData.getData('Text');
    if (isNaN(pastedData)) {
      event.preventDefault();
    } else {
      return;
    }
  }
  var keyCode = event.keyCode || event.which;
  if (keyCode >= 96 && keyCode <= 105) {
    // Numpad keys
    keyCode -= 48;
  }
  var charValue = String.fromCharCode(keyCode);
  if (isNaN(parseInt(charValue)) && event.keyCode != 8) {
    event.preventDefault();
  }
}
